module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/063-japan-4177ecea05a8e0386c15ea98c6e7a17e.svg";